import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./components/common.css";
import "animate.css"
import MetaInfo from 'vue-meta-info'
createApp(App).use(store).use(router).use(MetaInfo).mount('#app')

